/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByCloudResourceWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByCloudResourceWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByCloudResourceWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByCloudResourceWidgetConfiguration>): CostSpendByCloudResourceWidgetConfiguration {
        let obj = Object.assign(new CostSpendByCloudResourceWidgetConfiguration(), model);
        CostSpendByCloudResourceWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByCloudResourceWidgetConfiguration>): CostSpendByCloudResourceWidgetConfiguration {
        if (!model) return null;
        return CostSpendByCloudResourceWidgetConfiguration.newInstance(<CostSpendByCloudResourceWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByCloudResourceWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByCloudResourceWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByCloudResourceWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByCloudResourceWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of Category
     */
    categoryType: models.CategoryType;

}
